import { ModuleRegisterContext, ModuleRegisterFn } from "@/module-register"

const registerSchedulingModule: ModuleRegisterFn = (_context: ModuleRegisterContext) => {
  console.log("scheduling module registered!")
}

export default registerSchedulingModule
